/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import _isArray from 'lodash/isArray';
import _size from 'lodash/size';
import imageCompression from 'browser-image-compression';
import _isObject from 'lodash/isObject';
import _isBoolean from 'lodash/isBoolean';
import { getImageOrientation } from './getImageOrientation';

// eslint-disable-next-line import/prefer-default-export
export const generateID = () => `_${Math.random().toString(36).substr(2, 9)}`;

export const toggleSelected = (arr, id) => {
  if (arr.some((i) => i === id)) {
    return arr.filter((i) => i !== id);
  }
  return [...arr, id];
};

export const transformOrderFromAscToBoolean = (v) => v === 'asc';

export const transformOrderFromBooleanToAsc = (v) => (v ? 'asc' : 'desc');

export const isHasEmptyValue = (data) => {
  const hasError = Object.values(data).some((v) => (_isArray(v) ? !_size(v) : !v));
  return hasError;
};

export const isEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const createFormData = (data) => {
  const formData = new FormData();
  const keys = Object.keys(data);
  keys.forEach((k) => {
    if (_isObject(data[k]) && !data[k].type) {
      formData.append(k, JSON.stringify(data[k]));
    } else {
      formData.append(k, data[k]);
    }
  });
  return formData;
};

export const createFormDataWithDeepObj = (data, booleanAsNumber) => {
  const formData = new FormData();
  const keys = Object.keys(data);
  keys.forEach((k) => {
    if (_isObject(data[k]) && !data[k].type) {
      const objKeys = Object.keys(data[k]);
      objKeys.forEach((deepKey) => {
        const keyName = [k, '[', deepKey, ']'].join('');
        if (_isBoolean(data[k][deepKey]) && booleanAsNumber) {
          formData.append(keyName, Number(data[k][deepKey]));
        } else {
          formData.append(keyName, data[k][deepKey]);
        }
      });
    } else if (Array.isArray(data[k])) {
      data[k].forEach((val) => {
        formData.append(`${k}[]`, val);
      });
    } else if (_isBoolean(data[k]) && booleanAsNumber) {
      formData.append(k, Number(data[k]));
    } else {
      formData.append(k, data[k]);
    }
  });
  return formData;
};

export const prepareDataWithDeepObj = (data, booleanAsNumber) => {
  let dataToPost = {};
  const keys = Object.keys(data);
  keys.forEach((k) => {
    if (_isObject(data[k]) && !data[k].type) {
      const objKeys = Object.keys(data[k]);
      objKeys.forEach((deepKey) => {
        const keyName = [k, '[', deepKey, ']'].join('');
        if (_isBoolean(data[k][deepKey]) && booleanAsNumber) {
          dataToPost = { ...dataToPost, [keyName]: Number(data[k][deepKey]) };
        } else {
          dataToPost = { ...dataToPost, [keyName]: data[k][deepKey] };
        }
      });
    } else if (Array.isArray(data[k])) {
      data[k].forEach((val) => {
        dataToPost = { ...dataToPost, [`${k}[]`]: val };
      });
    } else if (_isBoolean(data[k]) && booleanAsNumber) {
      dataToPost = { ...dataToPost, [k]: Number(data[k]) };
    } else {
      dataToPost = { ...dataToPost, [k]: data[k] };
    }
  });
  return dataToPost;
};

export const transformInToFormObject = (formData, data, parentKey) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
    Object.keys(data).forEach((key) => {
      transformInToFormObject(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;
    formData.append(parentKey, value);
  }
};

export const createFormDataObject = (payload) => {
  const fData = new FormData();
  transformInToFormObject(fData, payload);
  return fData;
};

export const getTimeWithZero = (date, callback) => {
  let timeValue = date[callback](date);
  if (callback === 'getMonth') timeValue += 1;
  return String(timeValue).length < 2 ? `0${timeValue}` : timeValue;
};

export const formatDate = (date) => {
  const dateObject = new Date(date) || new Date();
  return `${getTimeWithZero(dateObject, 'getMonth')}/${getTimeWithZero(dateObject, 'getDate')}/${dateObject.getFullYear()} ${getTimeWithZero(dateObject, 'getHours')}:${getTimeWithZero(dateObject, 'getMinutes')}:${getTimeWithZero(dateObject, 'getSeconds')}`;
};

export const optimizeImage = async (file, options = {}) => imageCompression(file, {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  exifOrientation: await getImageOrientation(file),
  ...options,
});

export const compressMultipleImages = async (filesList, options = {}) => Promise.all(
  Object.values(filesList).map((f) => {
    const compressed = optimizeImage(f, options);
    return compressed;
  }),
);

export const compressArrayOfImages = async (imagesArray, options = {}) => Promise.all(
  imagesArray.map((f) => {
    if (f.type === 'application/pdf') return f;
    const compressed = optimizeImage(f, options);
    return compressed;
  }),
);

export const fixIndex = (index, arrLength) => {
  if (index < 0) return arrLength - 1;
  if (index > arrLength - 1) return 0;
  return index;
};

export const preRenderRouteMiddlware = (valid) => valid;

export const isOnlyNumbers = (val) => {
  const regex = new RegExp('^[0-9]+$');
  return regex.test(val);
};

export const createReducerNames = (reducerName, keys) => {
  const names = {};
  const keysArr = Object.keys(keys);
  keysArr.forEach((key) => {
    names[key] = `${reducerName}/${key}`;
  });
  return names;
};

export const mockRequest = (requestBody, shouldReturn) => new Promise((resolve) => {
  setTimeout(() => {
    resolve({
      sendedBody: requestBody,
      data: shouldReturn,
    });
  }, 1000);
});

// eslint-disable-next-line import/prefer-default-export
export const partitionFieldsAssignUnassign = (currentData = [], updatedData = []) => {
  const assign = updatedData
    .filter((a) => !currentData.includes(a));

  const unassign = currentData
    .filter((u) => !updatedData.includes(u));

  return {
    assign,
    unassign,
  };
};

export const pluralString = (stringToFormat, numberOfItems) => {
  if (numberOfItems === 1) return `${stringToFormat}s`;
  return stringToFormat;
};

export const parseCanvasserFullName = (canvasser) =>
  canvasser.first_name && canvasser.last_name
    ? `${canvasser.first_name} ${canvasser.last_name}`
    : canvasser.email;
